module.exports = __webpack_public_path__ + "img/wf1.f5a67883.png";